import { ButtonIcon, Tooltip } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { useLocation, useMatch, useNavigate, useSearchParams } from 'react-router-dom';
import { METRIC_KEY, SETTINGS_PANEL } from '@/consts/searchKeys';
import { useQueryParam } from '@/hooks/useQueryParam';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';

export const SettingsButton = () => {
  const { t } = useTranslation('visualisation');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);
  const isPreview = pathname.includes('/preview');
  const isRadarPage = !!useMatch('/:locale/:entity/:id/radar/*');
  const isSettingsPanelOpen = useQueryParam(SETTINGS_PANEL);
  const appearanceText = t('appearance');

  const handleClick = () => {
    const shouldOpen = isPreview || !isSettingsPanelOpen;

    const paramsToRemove = isRadarPage ? [METRIC_KEY] : [];
    const queryString = shouldOpen
      ? updateQueryString([{ key: SETTINGS_PANEL, value: 'true' }], paramsToRemove)
      : updateQueryString([], [SETTINGS_PANEL]);

    const basePath = isPreview ? '.' : '';
    navigate(`${basePath}?${queryString}`, { relative: 'route' });
  };

  return (
    <Tooltip content={appearanceText}>
      <ButtonIcon icon="Appearance" onClick={handleClick} variant="ghost">
        {appearanceText}
      </ButtonIcon>
    </Tooltip>
  );
};
